// useTicketAnalytics customHook

import { useShoppingCartStore } from "@multicines/stores";
import { MulticinesCartProduct } from "@multicines/types";
import { useCallback, useEffect, useMemo } from "react";

import useAnalytics from "hooks/analytics/useAnalytics";
import { useStoresStore } from "stores/stores/stores.store";

const useTicketAnalytics = () => {
  const selectedStore = useStoresStore(store => store.selectedStore);
  const shoppingCart = useShoppingCartStore(store => store.shoppingCart);
  const analyticsHook = useAnalytics({
    isSnackWorkflow: false
  });

  const [ticketsStore] = selectedStore ?? [];

  const { canBeSendAnalytics } = analyticsHook;
  const { logViewTickets } = analyticsHook;
  const { logAddProductToCart } = analyticsHook;

  const { id: shoppingCartId, name: shoppingCartName } = shoppingCart ?? {};

  const logAddProductToCartEvent = useCallback(
    (ticket: MulticinesCartProduct) => {
      if (!shoppingCartId || !shoppingCartName || !ticketsStore) return;

      logAddProductToCart({
        product: ticket,
        cartId: shoppingCartId,
        cartName: shoppingCartName,
        store: ticketsStore
      });
    },
    [logAddProductToCart, shoppingCartId, shoppingCartName, ticketsStore]
  );

  useEffect(() => {
    if (!canBeSendAnalytics) return;

    logViewTickets();
  }, [canBeSendAnalytics, logViewTickets]);

  return useMemo(() => {
    return {
      logAddProductToCartEvent
    };
  }, [logAddProductToCartEvent]);
};

export default useTicketAnalytics;
